export default {
  active_orders: {
    title: 'Aktywne zamówienia',
  },
  order_history: {
    title: 'Historia zamówień',
  },
  menu: {
    title: 'Menu',
  },
  printer_settings: {
    title: 'Ustawienia drukarki',
  },
  order_control: {
    title: 'Kontrola zamówień',
  },
  busy_mode: {
    title_zero: 'Tryb zajęty',
    title_other: 'Tryb zajęty (+{{time}} min)',
  },
  volume: {
    title: 'Głośność',
  },
  switch_language: {
    title: 'Zmień język ({{language}})',
  },
  logout: {
    title: 'Wyloguj',
    description: 'Czy na pewno chcesz się wylogować?',
    buttons: {
      confirm: 'Tak',
      cancel: 'Anuluj',
    },
  },
};
